<template>
  <div class="board-canvas-wrap" ref="boardContent">
    <div class="board-canvas">
      <board-column
        v-for="col in columns"
        :key="col.key"
        :column="col"
        :items="getColumnItems(col)"
        :sort="sort"
        :hideAddButton="hideAddButton"
        :controls="controls"
        @toggleItemSelection="toggleElementSelection"
        @editItem="handleEditItem"
        @addItem="$emit('addItem', $event)"
        @removeItem="$emit('removeItem', $event)"
        @createItem="$emit('createItem', $event)"
        @reorderItems="$emit('reorderItems', $event)"
      />
    </div>
  </div>
</template>

<script>
import BoardColumn from './BoardColumn';

import Selecto from 'selecto';
import { Sortable, MultiDrag } from 'sortablejs';

const installMultiDrag = () => {
  if (window.multiDrag) return;
  const multiDragPlugin = new MultiDrag();
  multiDragPlugin.prototype._deselectMultiDrag = () => {};
  Sortable.mount(multiDragPlugin);
  window.multiDrag = true;
};

export default {
  name: 'BoardCanvas',
  components: {
    BoardColumn,
  },
  data() {
    return {
      selecto: null,
    };
  },
  props: {
    /* columns = [{ title: '', key: '' }] */
    columns: {
      type: Array,
      default: () => [],
    },
    /* items = [{ title: '', id: '', [groupByField]: ''] }] */
    items: {
      type: Array,
      default: () => [],
    },
    controls: {
      type: Array,
      default: () => [],
    },
    groupByField: String,
    sort: Boolean,
    hideAddButton: Boolean,
  },
  methods: {
    getColumnItems(column) {
      return this.items.filter((i) => {
        return i[this.groupByField] === column.key;
      });
    },

    handleEditItem(item) {
      this.$emit('editItem', item);

      // deselect / select card
      this.toggleElementSelection(item.id);
    },

    toggleElementSelection(itemId) {
      const boardCard = document.getElementById(itemId);
      if (boardCard) {
        const isSelected = boardCard.classList.contains('selected');
        this.toggleCardSelection(boardCard, !isSelected);
      }
    },

    destroySelecto() {
      if (!this.selecto) return;
      this.selecto.destroy();
    },

    initSelecto() {
      const boardContent = this.$refs.boardContent;

      this.selecto = new Selecto({
        // The container to add a selection element
        container: boardContent,
        // Selecto's root container (No transformed container. (default: null)
        // rootContainer: null,
        // The area to drag selection element (default: container)
        // dragContainer: Element,
        // Targets to select. You can register a queryselector or an Element.
        selectableTargets: ['.board-card'],
        // Whether to select by click (default: true)
        selectByClick: false,
        // Whether to select from the target inside (default: true)
        selectFromInside: false,
        // After the select, whether to select the next target with the selected target (deselected if the target is selected again).
        continueSelect: false,
        // Determines which key to continue selecting the next target via keydown and keyup.
        toggleContinueSelect: 'shift',
        // The container for keydown and keyup events
        keyContainer: boardContent,
        // The rate at which the target overlaps the drag area to be selected. (default: 100)
        hitRate: 50,
      });

      this.selecto.on('select', (e) => {
        e.added.forEach((el) => {
          this.toggleCardSelection(el, true);
        });
        e.removed.forEach((el) => {
          return false;
        });
      });
    },

    async toggleCardSelection(boardCardElement, selected) {
      await this.$nextTick();
      const vueInstance = boardCardElement.__vue__;
      if (!vueInstance) {
        return false;
      }

      let method = selected ? 'select' : 'deselect';
      Sortable.utils[method](boardCardElement);
    },
  },
  created() {
    installMultiDrag();
  },
  mounted() {
    this.initSelecto();
  },
  beforeDestroy() {
    this.destroySelecto(false);
  },
};
</script>

<style lang="less" src="@/assets/styles/boards/boards.less"></style>
